var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            top: "5vh",
            visible: _vm.dialogVisible,
            width: "70%",
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-top" },
            [
              _c("el-input", {
                staticStyle: { width: "300px", "margin-left": "10px" },
                attrs: { clearable: "", placeholder: "请输入用户编号/名称" },
                model: {
                  value: _vm.searchData.Keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchData, "Keyword", $$v)
                  },
                  expression: "searchData.Keyword",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "dialog-center",
            },
            [
              _c(
                "el-table",
                {
                  ref: "dialogTable",
                  class:
                    _vm.type == "checkBox" ? "checkBoxTable" : "radioTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, height: "calc(100% - 40px)" },
                  on: {
                    "selection-change": _vm.handleSelectionChange,
                    select: _vm.handleSelect,
                    "row-click": _vm.handleRowClick,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "", width: "50", type: "selection" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "50", type: "index" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "头像",
                      align: "center",
                      prop: "HeadImg",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-avatar", {
                              attrs: {
                                src: scope.row.HeadImg,
                                icon: "el-icon-user-solid",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "用户名账号",
                      align: "center",
                      prop: "UserName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "姓名",
                      align: "center",
                      prop: "RealName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "性别",
                      align: "center",
                      prop: "SexText",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "手机号",
                      align: "center",
                      prop: "Telephone",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属角色",
                      align: "center",
                      prop: "RoleNames",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "当前状态",
                      align: "center",
                      prop: "EmployeStatus",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.EmployeStatus
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v("离职"),
                                ])
                              : _vm._e(),
                            !scope.row.EmployeStatus
                              ? _c("el-tag", [_vm._v("在职")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "40px",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "right",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pagination.PageIndex,
                      "page-sizes": _vm.pagination.PageSizes,
                      "page-size": _vm.pagination.PageRows,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.pagination.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }